<template lang="pug">
.fw--toast(v-if="isOpen")
  .fw--toast-box
    font-awesome-icon(v-if="icon", :icon="icon")
    p {{ message }}
</template>

<script>

export default {
  name: 'ToastBox',
  props: {
    programmatic: Boolean,
    type: String,
    icon: {
      type: Array,
      default: null
    },
    message: {
      type: String,
      default: ''
    },
    onComplete: {
      type: Function,
      default: () => {}
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  beforeMount() {
    // Insert the Modal component in body tag
    // only if it's programmatic
    console.log(this.programmatic)
    this.programmatic && document.body.appendChild(this.$el)
  },
  mounted () {
    console.log('ToastBox')
    if (this.programmatic) this.isOpen = true
  },
  computed: {
  },
  methods: {
    toggle () {
      this.isOpen = !this.isOpen

      if (this.isOpen) {
        this.$emit('openDialog')
      } else {
        this.$emit('closeDialog')
      }
    },
    close () {
      //this.$emit('closeDialog')
      this.isOpen = false
      // Timeout for the animation complete before destroying
      if (this.programmatic) {
          //this.isActive = false
          setTimeout(() => {
              this.$destroy()
              this.$el.parentNode.removeChild(this.$el)
          }, 150)
      }
    },
    confirm () {
      this.onComplete()
      this.close()
    },
  },
  watch: {
    open: function (val) {
      //console.log('manual close = ' + val);
      this.isOpen = val
    }
  },
  beforeDestroy() {
  }
}
</script>

<style scoped lang="stylus">
</style>
